export default "/images/claritick_tm_dark.svg?4998c78d077402be5588ad1146edff33";